import React from 'react';
import { motion } from 'framer-motion';

const AdminTable = ({
  columns,
  data,
  onRowClick,
  emptyState,
  loading = false,
  className = '',
  stickyHeader = true,
  zebraRows = true,
  compact = false
}) => {
  if (loading) {
    return (
      <div className="admin-table-loading">
        <div className="admin-spinner" />
        <p>Loading data...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return emptyState || (
      <div className="admin-table-empty">
        <p>No data available</p>
      </div>
    );
  }

  return (
    <div className={`admin-table-wrapper ${className}`}>
      <table className={`admin-table ${compact ? 'admin-table-compact' : ''} ${zebraRows ? 'admin-table-zebra' : ''}`}>
        <thead className={stickyHeader ? 'admin-table-header-sticky' : ''}>
          <tr>
            {columns.map((column, index) => (
              <th
                key={column.key || index}
                className="admin-table-header-cell"
                style={{ width: column.width, textAlign: column.align || 'left' }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <motion.tr
              key={row.id || rowIndex}
              className={`admin-table-row ${onRowClick ? 'admin-table-row-clickable' : ''}`}
              onClick={() => onRowClick && onRowClick(row)}
              whileHover={onRowClick ? { backgroundColor: 'rgba(59, 130, 246, 0.05)' } : {}}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: rowIndex * 0.02 }}
            >
              {columns.map((column, colIndex) => (
                <td
                  key={column.key || colIndex}
                  className="admin-table-cell"
                  style={{ textAlign: column.align || 'left' }}
                >
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </motion.tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTable;

